/**
 * Kampagnen-Parameter (UTM + gclid) aus der Einstiegs-URL merken und auf der
 * Formularseite in die versteckten Felder schreiben (DLYE-4872).
 *
 * Hintergrund: Nutzer kommen ueber eine Anzeige auf eine Landingpage, das
 * Formular liegt aber meist auf einer anderen Seite. Deshalb werden die
 * Parameter beim ersten Aufruf im sessionStorage abgelegt und erst auf der
 * Formularseite in die Felder geschrieben. Von dort uebergibt der
 * Dynamics-Finisher sie als het_utm_source, het_utm_medium, het_utm_campaign
 * und het_gclid ans CRM.
 *
 * Bewusst clientseitig: die Formularseiten liegen im TYPO3-Cache, ein
 * serverseitiges Vorbefuellen wuerde die Werte des ersten Besuchers an alle
 * folgenden ausliefern.
 */

const STORAGE_KEY = 'hettich_campaign';

/**
 * Bezeichner der versteckten Formularfelder aus dem Formular-Backend. Das
 * Mapping auf die Dynamics-Felder steht im Finisher des jeweiligen Formulars.
 */
const FIELD_MAP = {
  'hidden-1': 'utm_source',
  'hidden-2': 'utm_medium',
  'hidden-3': 'utm_campaign',
  'hidden-4': 'gclid',
};

const PARAMETERS = Object.values(FIELD_MAP);

/** Laengenbegrenzung, damit manipulierte URLs keine ueberlangen Werte ins CRM tragen. */
const MAX_LENGTH = 255;

const readFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const values = {};

  PARAMETERS.forEach((parameter) => {
    const value = (params.get(parameter) || '').trim();
    if (value) {
      values[parameter] = value.slice(0, MAX_LENGTH);
    }
  });

  return values;
};

const store = (values) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
  } catch (e) {
    // Privater Modus oder gesperrter Storage: dann greift nur die aktuelle URL.
  }
};

const load = () => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    return stored && typeof stored === 'object' ? stored : {};
  } catch (e) {
    return {};
  }
};

const findField = (form, identifier) => form.querySelector(`input[type="hidden"][name$="[${identifier}]"]`);

/**
 * Nur Formulare befuellen, die alle vier Felder mitbringen. Die Bezeichner
 * hidden-1 bis hidden-4 vergibt das Formular-Backend automatisch, ein anderes
 * Formular koennte sie also fuer etwas anderes nutzen.
 */
const isCampaignForm = (form) => Object.keys(FIELD_MAP)
  .every((identifier) => findField(form, identifier));

const fill = (values) => {
  document.querySelectorAll('form').forEach((form) => {
    if (!isCampaignForm(form)) {
      return;
    }

    Object.entries(FIELD_MAP).forEach(([identifier, parameter]) => {
      findField(form, identifier).value = values[parameter] || '';
    });
  });
};

const fromUrl = readFromUrl();
const hasUrlValues = Object.keys(fromUrl).length > 0;

if (hasUrlValues) {
  // Letzter Klick gewinnt: ein neuer Kampagnenbesuch ersetzt den alten Satz
  // komplett, damit Quelle, Medium und Kampagne zueinander passen.
  store(fromUrl);
}

const campaign = hasUrlValues ? fromUrl : load();

if (Object.keys(campaign).length > 0) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fill(campaign));
  } else {
    fill(campaign);
  }
}
